import { render, staticRenderFns } from "./basic-videopicstext-swiper-new.vue?vue&type=template&id=4b31b45c&scoped=true&"
import script from "./basic-videopicstext-swiper-new.vue?vue&type=script&lang=js&"
export * from "./basic-videopicstext-swiper-new.vue?vue&type=script&lang=js&"
import style0 from "./basic-videopicstext-swiper-new.vue?vue&type=style&index=0&id=4b31b45c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31b45c",
  null
  
)

export default component.exports